export default "__VITE_ASSET__BsTIWHDA__"